var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"qrCardContainer",attrs:{"flat":"","color":"blue","rounded":"lg"}},[_c('v-img',{attrs:{"src":require('@/assets/images/QrCode.svg')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }